<template>
  <div class="card">
    <div class="position-relative">
      <img class="card-img-top" :src="simulator.icon_image" />
      <div class="card-body">
        <h4>{{ simulator.name }}</h4>
        {{ simulator.subtitle }}
      </div>
    </div>
    <div class="card-footer">
      <router-link
        class="btn btn-primary"
        :to="{
          name: 'tools',
          params: { slug: 'simulators', subslug: simulator.slug }
        }"
      >
        Realizar simulado
      </router-link>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    simulator: {
      type: Object,
      required: true
    }
  }
};
</script>
<style lang="scss" scoped>
.card {
  background-color: rgba(0, 0, 0, 0.5) !important;
  width: 100%;
  height: 100%;
  border: none !important;
  border-radius: 8px !important;
  overflow: hidden;
  position: relative;

  .card-body {
    position: absolute;
    bottom: 0;
    left: 0;
    background-image: linear-gradient(to bottom, transparent, #000c);
    width: 100%;
    padding-bottom: 16px;
    padding-top: 32px;
    text-shadow: 0 1px 10px #000c;
  }

  .card-img-top {
    aspect-ratio: 8 / 5;
    object-fit: cover;
    opacity: 0.8;
  }

  .card-footer {
    border: none;
    background-color: none;
    padding: 48px 40px 32px;

    .btn {
      display: flex;
      align-items: center;
      justify-content: center;
      position: unset;
    }
  }
}
</style>
